<template>

    <div>
        <loading />
        <notifications />
        <header-cna />
        <router-view />
        <footer-cna />
    </div>

</template>
<script>

    import footerCna from '@/template/footer'
    import headerCna from '@/template/header'
    import loading from '@/common/components/loading'

    export default {
        name: "Template",
        components: { footerCna, headerCna, loading },
        data() {
            return {

            };
        },
        mounted() {
            this.$eventHub.$on('show-notification', (data) => {
                this.$notify({
                    type: data.type,
                    title: data.title,
                    text: data.text,
                    duration: 10000,
                    speed: 1000
                })
                this.snackbar_color = data.type;
                this.snackbar_showing = true;
            })
        },
        beforeDestroy() {
            this.$eventHub.$off('show-notification');
        },
    };
</script>
